import loadable from '@loadable/component';

export const namespace = 'canalplus.block.selfcare.subscription_options_list';
export const Component = loadable(
  () => import('./containers/SubscriptionOptionsListContainer')
);
export { default as propsFormatter, getFormattedApis } from './propsFormatter';
